






import { Component, Vue } from 'vue-property-decorator';
import ConstraintsGraph from '@/components/ConstraintsGraph.vue';

@Component({
  components: {
  ConstraintsGraph,
  },
  })
export default class App extends Vue {}
